import MUIDataTable from 'mui-datatables'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { Log } from '../../app/models/Log'
import { formatToLocalDate } from '../../app/helpers'

interface Props {
  logs: Log[]
}

function LogsTable({ logs }: Props) {
  const { t, i18n } = useTranslation()

  const data = logs.map((m) => ({
    id: m.id,
    userEmail: m.userEmail,
    date: (m.date = formatToLocalDate(m.date, i18n.language)),
    activity: m.activity,
    ipAddress: m.ipAddress,
  }))

  const columns = [
    { name: 'userEmail', label: t('userEmail') },
    { name: 'date', label: t('date') },
    { name: 'activity', label: t('activity') },
    { name: 'ipAddress', label: t('ipAddress') },
  ]
  return (
    <MUIDataTable
      title={t('logs_list')}
      data={data}
      columns={columns}
      options={{
        responsive: 'vertical',
        viewColumns: true,
        selectableRows: 'none',
        rowsPerPage: 10,
        rowsPerPageOptions: [5, 10, 15, 20],
        tableBodyHeight: '60vh',
      }}
    />
  )
}
export default observer(LogsTable)
